export const skillChoiceOptions = (item, skills) => {
    const allowed = item?.SkillChoice?.Skills
    const list = Array.isArray(allowed) && allowed.length ? skills.filter((s) => allowed.includes(s.Key)) : skills
    return [...list].sort((a, b) => a.skill.localeCompare(b.skill))
}

export const applySkillChoice = (item, skillKey, skills) => {
    if (!item?.SkillChoice || !skillKey) { return item }
    const choice = item.SkillChoice
    const mod = { Key: skillKey }
    if (choice.SkillIsCareer) { mod.SkillIsCareer = "true" }
    if (parseInt(choice.Count) > 0) { mod.Count = String(choice.Count) }
    const baseMods = item.BaseMods ? (Array.isArray(item.BaseMods) ? [...item.BaseMods] : [item.BaseMods]) : []
    const skillName = skills.find((s) => s.Key === skillKey)?.skill || skillKey
    const next = { ...item, BaseMods: [...baseMods, mod], Name: `${item.Name} (${skillName})`, ChosenSkill: skillKey }
    delete next.SkillChoice
    return next
}
